import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-cream py-16 md:py-20" data-id="element-175">
      <div className="max-w-4xl mx-auto px-6" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-177">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-178">
            <SparklesIcon className="w-8 h-8 text-amber-600" data-id="element-179" />
            <h2 className="text-3xl md:text-4xl font-bold text-center text-teal-900" data-id="element-180">
              El Mecanismo Único
            </h2>
            <SparklesIcon className="w-8 h-8 text-amber-600" data-id="element-181" />
          </div>

          <div className="bg-white p-8 md:p-10 rounded-lg shadow-sm" data-id="element-182">
            <h3 className="text-2xl md:text-3xl font-bold text-teal-900 mb-6 text-center" data-id="element-183">
              El Protocolo de Nutrición Cerebral Anti-inflamatoria
            </h3>

            <p className="text-lg md:text-xl leading-relaxed mb-6 text-gray-800" data-id="element-184">
              Este método no es una dieta para adelgazar. Es un "re-cableado"
              metabólico. Al usar la{' '}
              <span className="font-semibold text-amber-700" data-id="element-185">
                Regla de los 3 Colores
              </span>{' '}
              y el{' '}
              <span className="font-semibold text-amber-700" data-id="element-186">
                Interruptor de Energía Neuronal
              </span>
              , enseñamos a tu cerebro a utilizar fuentes de combustible
              alternativas que no dependen del estrógeno.
            </p>

            <p className="text-lg md:text-xl leading-relaxed text-gray-800" data-id="element-187">
              Apagamos la inflamación de la microglía (las células de defensa de
              tu cerebro) para que la comunicación entre neuronas vuelva a ser
              eléctrica y veloz.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}